import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import {PointTableUI } from './PointTableUI'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class PointTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetPoint?offset=";
    this.className = "GetPoint";
    this.state.mode = "table";
  }



  render() {
    if (!this.state.isLoaded) {
      return <div className="box-body"> در حال بارگذاری</div>;
    }


    return (
      <div className="container">

        <PointTableUI data={this.state.data} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/point/PointTable.js